/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import TextCard from "../../Cards/TextCard/TextCard";
import Container from "../../Container/Container";
import TextContainer from "../../Container/TextContainer";
import Button from "@mui/material/Button";
import { Link } from "react-router";
import CrossIcon from "../../../assets/icons/common/toggleable/IconClose";
import { Typography } from "@mui/material";

const DocumentGenerationFailed = () => {
  return (
    <Container>
      <TextCard boxHeading={"Leider ist ein technisches Problem aufgetreten"} headingColor={"primary"} minHeadingHeight={0}>
        <TextContainer sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <CrossIcon sx={{ width: 100, height: 100 }} />
          <Typography sx={{ marginTop: "1rem", textAlign: "center", marginBottom: "1rem" }}>
            Bei der Generierung Ihres Dokuments ist ein technisches Problem aufgetreten. Bitte wenden Sie sich an unseren Kundenservice service@legalbird.de .
          </Typography>
          <Button fullWidth variant={"contained"} color="primary" component={Link} to={"/servicewelt"}>
            Zurück zur Servicewelt
          </Button>
        </TextContainer>
      </TextCard>
    </Container>
  );
};

export default DocumentGenerationFailed;
